'use strict';

/**
 * Shared scrollbar indicator for Live Shopping carousels.
 *
 * @param {HTMLElement} carousel  - The scrollable container element.
 * @param {HTMLElement} thumb     - The scrollbar thumb element (child of the track).
 * @param {Object}      [config] - Optional configuration.
 * @param {string}      [config.inactiveClass] - CSS class toggled on the track when
 *                                  scrolling is not possible. Defaults to 'cc-scrollbar--inactive'.
 * @param {number}      [config.maxThumbPx]    - Maximum thumb width in pixels. Omit for no cap.
 */
function updateScrollIndicator (carousel, thumb, config) {
    if (!carousel || !thumb || !thumb.parentElement) {
        return;
    }

    var options = config || {};
    var inactiveClass = options.inactiveClass || 'cc-scrollbar--inactive';
    var scrollbar = thumb.parentElement;
    var trackWidth = scrollbar.clientWidth;

    if (trackWidth <= 0) {
        scrollbar.classList.add(inactiveClass);
        return;
    }

    var maxScroll = carousel.scrollWidth - carousel.clientWidth;

    if (maxScroll <= 0) {
        scrollbar.classList.add(inactiveClass);
        thumb.style.width = trackWidth + 'px';
        thumb.style.transform = 'translateX(0px)';
        return;
    }

    scrollbar.classList.remove(inactiveClass);

    var thumbWidthPx =
        (carousel.clientWidth / carousel.scrollWidth) * trackWidth;
    var minThumbPx = trackWidth * 0.12;

    if (thumbWidthPx < minThumbPx) {
        thumbWidthPx = minThumbPx;
    }
    if (options.maxThumbPx && thumbWidthPx > options.maxThumbPx) {
        thumbWidthPx = options.maxThumbPx;
    }
    if (thumbWidthPx > trackWidth) {
        thumbWidthPx = trackWidth;
    }

    var maxTranslatePx = trackWidth - thumbWidthPx;
    var leftPx = (carousel.scrollLeft / maxScroll) * maxTranslatePx;

    thumb.style.width = thumbWidthPx + 'px';
    thumb.style.transform = 'translateX(' + leftPx + 'px)';
}

/**
 * Bind scroll events so the thumb tracks the carousel position.
 *
 * @param {HTMLElement} carousel - The scrollable container element.
 * @param {HTMLElement} thumb    - The scrollbar thumb element.
 * @param {Object}      [config] - Same options as updateScrollIndicator.
 */
function bindScrollbar (carousel, thumb, config) {
    if (!carousel || !thumb) {
        return;
    }

    updateScrollIndicator(carousel, thumb, config);

    carousel.addEventListener('scroll', function () {
        updateScrollIndicator(carousel, thumb, config);
    });
}

module.exports = {
    updateScrollIndicator: updateScrollIndicator,
    bindScrollbar: bindScrollbar,
};
